module.exports = __webpack_public_path__ + "public/images/dragon.d3f9c4a29126f6b86f18cc2923840ff8.png";